// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"CardOverlay_overlayContainer__Mj751","overlayContainerAbsolute":"CardOverlay_overlayContainerAbsolute__o5zYC","active":"CardOverlay_active__1ShyG"};